/**
 * Reads a byte stream of newline-delimited JSON, calling `onLine` for each complete line as soon
 * as it is whole. A line split across chunks (even in the middle of a multi-byte character) is
 * held until its newline arrives; a last line with no newline is read at the end. Blank lines are
 * skipped. A line that is not JSON rejects, so the caller can fall back.
 */
export async function readNdjson<T>(
  body: ReadableStream<Uint8Array>,
  onLine: (line: T) => void,
): Promise<void> {
  const reader = body.getReader();
  const decoder = new TextDecoder();
  let pending = "";
  const emit = (text: string) => {
    const trimmed = text.trim();
    if (trimmed) onLine(JSON.parse(trimmed) as T);
  };
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    pending += decoder.decode(value, { stream: true });
    let newline = pending.indexOf("\n");
    while (newline >= 0) {
      emit(pending.slice(0, newline));
      pending = pending.slice(newline + 1);
      newline = pending.indexOf("\n");
    }
  }
  pending += decoder.decode();
  emit(pending);
}
